"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AccordionSummary_1 = __importDefault(require("@mui/material/AccordionSummary"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Typography_1 = __importDefault(require("../Typography"));
var prism_icons_1 = require("@octanner/prism-icons");
var StyledAccordionSummary = (0, styled_1.default)(AccordionSummary_1.default)({
    padding: "0px",
    height: "56px",
    '& .MuiAccordionSummary-expandIconWrapper': {
        color: "#000000",
    },
    '& .MuiAccordionSummary-content': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
});
var HelperTextWrapper = styled_1.default.span({
    paddingRight: '12px',
});
var AccordionSummary = function (_a) {
    var _b = _a.expandIcon, expandIcon = _b === void 0 ? react_1.default.createElement(prism_icons_1.ArrowDown, null) : _b, children = _a.children, classes = _a.classes, helperText = _a.helperText, sx = _a.sx;
    return (react_1.default.createElement(StyledAccordionSummary, { classes: classes, expandIcon: expandIcon, sx: sx },
        children,
        helperText && (react_1.default.createElement(HelperTextWrapper, null,
            react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textSecondary" }, helperText)))));
};
exports.default = AccordionSummary;
__exportStar(require("@mui/material/AccordionSummary"), exports);
//# sourceMappingURL=index.js.map